module.exports = __webpack_public_path__ + "media/images/mobile/service/m_line-dea81e83dd8442f020a117ab77272bbc.png";